import { useState, useEffect } from "react";

export const useLocalAuthScope = (scopeReady) => {
  const [auth, setAuth] = useState({
    scopeLevel: null,
    realm: null,
    orgs: null,
    sites: null,
    permissions: null,
  });
  const [isAuthReady, setIsAuthReady] = useState(false);

  useEffect(() => {
    if (scopeReady) {
      const storage = localStorage.getItem("selectBreadcrumbs");
      if (!storage) {
        setIsAuthReady(true);
        return;
      }
      try {
        const parsed = JSON.parse(storage);
        const { realm, orgs, site } = parsed;

        if (site && typeof site === "object" && Object.keys(site).length > 0) {
          setAuth({
            scopeLevel: "site",
            realm,
            orgs,
            sites: site,
            permissions: site.roleName,
          });
        } else {
          const currentPermissions = realm?.roleName || orgs?.roleName || "";
          setAuth({
            scopeLevel: "org",
            realm,
            orgs,
            permissions: currentPermissions,
          });
        }
      } catch (e) {
        console.error("Failed to parse selectBreadcrumbs:", e);
      }
      setIsAuthReady(true);
    }
  }, [scopeReady]);

  return { auth, isAuthReady };
};
